import { render, staticRenderFns } from "./cardVirtualConversationEdit.vue?vue&type=template&id=2ca6e3f6"
import script from "./cardVirtualConversationEdit.vue?vue&type=script&lang=js"
export * from "./cardVirtualConversationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports